export default __webpack_public_path__ + "css/report.bundle.css";